import { CustomSelectStateProps } from '@monetize/types/app';
import { MBox, MFlex } from '../chakra';
import MText from '../MText';
import CheckboxItemList from './components/CheckboxItemList';
import { ItemList } from './components/ItemList';

export type MCustomSelectItemListRenderProps = Pick<
  CustomSelectStateProps,
  | 'isSubtitleItem'
  | 'isDisabledItem'
  | 'isSelectedItem'
  | 'onClose'
  | 'itemRefs'
  | 'getTitle'
  | 'cursor'
  | 'items'
  | 'handleChange'
  | 'renderItemContent'
  | 'setCursor'
  | 'setCursorCurrent'
  | 'displayAvatar'
  | 'query'
  | 'useHighlightedItemList'
  | 'showItemDivider'
  | 'omitNoResultsText'
> & {
  indexOffset: number;
  checkboxDisplay?: boolean;
  rightLabel?: boolean;
};

const MCustomSelectItemListRender = ({
  cursor,
  displayAvatar,
  getTitle,
  handleChange,
  indexOffset,
  isDisabledItem,
  isSelectedItem,
  isSubtitleItem,
  itemRefs,
  items,
  onClose,
  renderItemContent,
  setCursor,
  setCursorCurrent,
  query,
  checkboxDisplay = false,
  useHighlightedItemList = false,
  showItemDivider,
  rightLabel,
  omitNoResultsText,
}: MCustomSelectItemListRenderProps) => {
  if (checkboxDisplay) {
    return (
      <CheckboxItemList
        indexOffset={indexOffset}
        isSelectedItem={isSelectedItem}
        isDisabledItem={isDisabledItem}
        isSubtitleItem={isSubtitleItem}
        itemRefs={itemRefs}
        getTitle={getTitle}
        cursor={cursor}
        setCursor={setCursor}
        setCursorCurrent={setCursorCurrent}
        items={items}
        handleChange={handleChange}
        renderItemContent={renderItemContent}
        query={query}
        rightLabel={rightLabel}
        omitNoResultsText={omitNoResultsText}
      />
    );
  }

  return (
    <>
      <ItemList
        indexOffset={indexOffset}
        items={items}
        isSubtitleItem={isSubtitleItem}
        isDisabledItem={isDisabledItem}
        isSelectedItem={isSelectedItem}
        onClose={onClose}
        itemRefs={itemRefs}
        getTitle={getTitle}
        cursor={cursor}
        handleChange={handleChange}
        renderItemContent={renderItemContent}
        setCursorCurrent={setCursorCurrent}
        displayAvatar={displayAvatar}
        query={query}
        useHighlightedItemList={useHighlightedItemList}
        showItemDivider={showItemDivider}
      />

      {!useHighlightedItemList && items.length === 0 && !omitNoResultsText && (
        <MBox p="2">No Results</MBox>
      )}

      {useHighlightedItemList && items.length === 0 && !omitNoResultsText && (
        <MFlex p={1} justify="center" align="center">
          <MText color="tGray.darkPurple">
            {query ? 'No search results found' : 'No results found'}
          </MText>
        </MFlex>
      )}
    </>
  );
};

export default MCustomSelectItemListRender;
